import type { KeywordLandingPageQuery } from '../../types';
import type { MetaDataContext } from './types';

type Props = {
  data: KeywordLandingPageQuery | undefined;
};

export default (kwlpData: Props, { market, t }: MetaDataContext) => {
  if (!kwlpData.data) return {};

  const {
    url,
    categories: { nodes: categories },
    title,
    inSitemap,
    parentCategory,
  } = kwlpData.data.keywordLandingPage;

  const canonical = market.domain + url;
  const noIndex = !inSitemap;
  const breadcrumb = parentCategory?.path;
  const firstLetterVariantA = /^[a-j]/i;
  const firstLetterVariantB = /^[k-t]/i;
  const AJVariant = firstLetterVariantA.test(title);
  const KTVariant = firstLetterVariantB.test(title);
  const keyword = `${title[0].toUpperCase()}${title.slice(1)}`;
  const isOffersOnly = !categories.length;
  const description = isOffersOnly
    ? t('meta', 'keyword-landing-page.description-offers-only', {
        keyword,
      })
    : t('meta', 'keyword-landing-page.description', {
        keyword,
        categories: categories.map(category => category?.name).join(' '),
      });

  const isExperimentalMarket = ['se', 'gb'].includes(market.code);
  let titleDescription = {};

  if (AJVariant && isExperimentalMarket) {
    titleDescription = {
      title: t('meta', 'keyword-landing-page.title', {
        keyword,
      }),
      description: t('meta', 'keyword-landing-page.description-experiment', {
        keyword,
      }),
    };
  } else if (KTVariant && isExperimentalMarket) {
    titleDescription = {
      title: t('meta', 'keyword-landing-page.title-experiment', {
        keyword,
      }),
      description,
    };
  } else {
    titleDescription = {
      title: t('meta', 'keyword-landing-page.title', {
        keyword,
      }),
      description,
    };
  }

  const maxImagePreview = 'standard';

  return {
    ...titleDescription,
    canonical,
    noIndex,
    breadcrumb,
    maxImagePreview,
  };
};
